/** When your routing table is too long, you can split it into small modules **/

import Layout from '@/layout'
import LayoutView from '@/layout/layout'

const orderingRouter = {
	path: '/orderCenter',
	component: Layout,
	redirect: 'noRedirect',
	name: '订单',
	id: 2000000,
	meta: {
		title: '订单',
		icon: 'component',
		roles: [2000000]
	},
	children: [{
		path: 'orderManagement',
		name: '当餐点餐',
		component: LayoutView,
		id: 2010000,
		meta: { title: '当餐点餐', roles: [2010000] },
		children: [
			{
				path: 'detail',
				component: () =>
					import(/* webpackChunkName: "orderdetail" */ '@/leniuview/orderCenter/orderManagement/orderDetail'),
				name: '订餐明细',
				id: 2011000,
				meta: { title: '订餐明细', roles: [2011000] }
			},
			{
				path: 'dishStatistics',
				component: () =>
					import(/* webpackChunkName: "orderdetail" */ '@/leniuview/orderCenter/orderManagement/dishStatistics'),
				name: '菜品统计',
				id: 2012000,
				meta: { title: '菜品统计', roles: [2012000] }
			},
			{
				path: 'peopleStatistics',
				component: () =>
					import(/* webpackChunkName: "orderdetail" */ '@/leniuview/orderCenter/orderManagement/peopleStatistics'),
				name: '用餐统计',
				id: 2013000,
				meta: { title: '用餐统计', roles: [2013000] }
			},
			{
				path: 'orderStatistics',
				component: () =>
					import(/* webpackChunkName: "orderdetail" */ '@/leniuview/orderCenter/orderManagement/orderStatistics'),
				name: '订单统计',
				id: 2014000,
				meta: { title: '订单统计', roles: [2014000] }
			},
			{
				path: 'courierDishStatisticscommon',
				component: () =>
					import(/* webpackChunkName: "orderdetail" */ '@/leniuview/orderCenter/orderManagement/courierDishStatisticscommon'),
				name: '配送明细',
				id: 2015000,
				meta: { title: '配送明细', roles: [2015000] }
			},
			{
				path: 'orderShenhe',
				component: () =>
					import(/* webpackChunkName: "orderdetail" */ '@/leniuview/orderCenter/orderManagement/orderShenhe'),
				name: '退款审核',
				id: 2016000,
				meta: { title: '退款审核', roles: [2016000] }
			}
		]
	},
	{
		path: 'reserveManagement',
		name: '预订餐',
		component: LayoutView,
		id: 2020000,
		meta: { title: '预订餐', roles: [2020000] },
		children: [
			{
				path: 'detail',
				component: () =>
					import(/* webpackChunkName: "orderdetail" */ '@/leniuview/orderCenter/reserveManagement/orderDetail'),
				name: '订餐明细',
				id: 2021000,
				meta: { title: '订餐明细', roles: [2021000] }
			},
			{
				path: 'dishStatistics',
				component: () =>
					import(/* webpackChunkName: "orderdetail" */ '@/leniuview/orderCenter/reserveManagement/dishStatistics'),
				name: '菜品统计',
				id: 2022000,
				meta: { title: '菜品统计', roles: [2022000] }
			},
			{
				path: 'peopleStatistics',
				component: () =>
					import(/* webpackChunkName: "orderdetail" */ '@/leniuview/orderCenter/reserveManagement/peopleStatistics'),
				name: '用餐统计',
				id: 2023000,
				meta: { title: '用餐统计', roles: [2023000] }
			},
			{
				path: 'orderStatistics',
				component: () =>
					import(/* webpackChunkName: "orderdetail" */ '@/leniuview/orderCenter/reserveManagement/orderStatistics'),
				name: '订单统计',
				id: 2024000,
				meta: { title: '订单统计', roles: [2024000] }
			},
			{
				path: 'courierDishStatisticscommon',
				component: () =>
					import(/* webpackChunkName: "orderdetail" */ '@/leniuview/orderCenter/reserveManagement/courierDishStatisticscommon'),
				name: '配送明细',
				id: 2025000,
				meta: { title: '配送明细', roles: [2025000] }
			},
			{
				path: 'orderShenhe',
				component: () =>
					import(/* webpackChunkName: "orderdetail" */ '@/leniuview/orderCenter/reserveManagement/orderShenhe'),
				name: '退款审核',
				id: 2026000,
				meta: { title: '退款审核', roles: [2026000] }
			},
			// {
			//   path: "chefDishStatistics",
			//   component: () =>
			//     import(/* webpackChunkName: "orderdetail" */ "@/leniuview/orderCenter/reserveManagement/chefDishStatistics"),
			//   name: "菜品销售表",
			//   id: 2027000,
			//   meta: { title: "菜品销售表", noCache:true, roles: [2027000]  }
			// },
			{
				path: 'courierDishStatistics',
				component: () =>
					import(/* webpackChunkName: "orderdetail" */ '@/leniuview/orderCenter/reserveManagement/courierDishStatistics'),
				name: '菜品配送表',
				id: 2028000,
				meta: { title: '菜品配送表', noCache: true, roles: [2028000] }
			}, {
				path: 'dishGet',
				component: () =>
					import(/* webpackChunkName: "orderdetail" */ '@/leniuview/orderCenter/reserveManagement/dishGet'),
				name: '菜品领取表',
				id: 2029000,
				meta: { title: '菜品领取表', noCache: true, roles: [2029000] }
			}
		]
	},
	{
		path: 'mealdeclarationManagement',
		name: '报餐',
		component: LayoutView,
		id: 2030000,
		meta: { title: '报餐', roles: [2030000] },
		children: [
			{
				path: 'detail',
				component: () =>
					import(/* webpackChunkName: "orderdetail" */ '@/leniuview/orderCenter/mealdeclarationManagement/orderDetail'),
				name: '报餐明细',
				id: 2031000,
				meta: { title: '报餐明细', roles: [2031000] }
			},
			{
				path: 'peopleStatistics',
				component: () =>
					import(/* webpackChunkName: "orderdetail" */ '@/leniuview/orderCenter/mealdeclarationManagement/peopleStatistics'),
				name: '用餐统计',
				id: 2032000,
				meta: { title: '用餐统计', roles: [2032000] }
			},
			{
				path: 'orderStatistics',
				component: () =>
					import(/* webpackChunkName: "orderdetail" */ '@/leniuview/orderCenter/mealdeclarationManagement/orderStatistics'),
				name: '订单统计',
				id: 2033000,
				meta: { title: '订单统计', roles: [2033000] }
			},
			{
				path: 'orderShenhe',
				component: () =>
					import(/* webpackChunkName: "orderdetail" */ '@/leniuview/orderCenter/mealdeclarationManagement/orderShenhe'),
				name: '退款审核',
				id: 2034000,
				meta: { title: '退款审核', roles: [2034000] }
			}
		]
	},
	{
		path: 'offlineManagement',
		name: '线下消费',
		component: LayoutView,
		id: 2050000,
		meta: { title: '线下消费', roles: [2050000] },
		children: [
			{
				path: 'detail',
				component: () =>
					import(/* webpackChunkName: "orderdetail" */ '@/leniuview/orderCenter/offlineManagement/orderDetail'),
				name: '订单明细',
				id: 2051000,
				meta: { title: '订单明细', roles: [2051000] }
			},
			{
				path: 'dishStatistics',
				component: () =>
					import(/* webpackChunkName: "orderdetail" */ '@/leniuview/orderCenter/offlineManagement/dishStatistics'),
				name: '菜品统计',
				id: 2052000,
				meta: { title: '菜品统计', roles: [2052000] }
			},
			// {
			//   path: "peopleStatistics",
			//   component: () =>
			//     import(/* webpackChunkName: "orderdetail" */ "@/leniuview/orderCenter/offlineManagement/peopleStatistics"),
			//   name: "下单统计",
			//   id: 2053000,
			//   meta: { title: "下单统计", roles: [2053000]  }
			// },
			{
				path: 'orderStatistics',
				component: () =>
					import(/* webpackChunkName: "orderdetail" */ '@/leniuview/orderCenter/offlineManagement/orderStatistics'),
				name: '订单统计',
				id: 2054000,
				meta: { title: '订单统计', roles: [2054000] }
			},
			{
				path: 'orderShenhe',
				component: () =>
					import(/* webpackChunkName: "orderdetail" */ '@/leniuview/orderCenter/offlineManagement/orderShenhe'),
				name: '退款审核',
				id: 2055000,
				meta: { title: '退款审核', roles: [2055000] }
			}
		]
	},
	{
		path: 'buffetManagement',
		name: '自助餐',
		component: LayoutView,
		id: 2060000,
		meta: { title: '自助餐', roles: [2060000] },
		children: [
			{
				path: 'detail',
				component: () =>
					import(/* webpackChunkName: "orderdetail" */ '@/leniuview/orderCenter/buffetManagement/orderDetail'),
				name: '订单明细',
				id: 2061000,
				meta: { title: '订单明细', roles: [2061000] }
			},
			{
				path: 'dishStatistics',
				component: () =>
					import(/* webpackChunkName: "orderdetail" */ '@/leniuview/orderCenter/buffetManagement/dishStatistics'),
				name: '菜品统计',
				id: 2062000,
				meta: { title: '菜品统计', roles: [2062000] }
			},
			{
				path: 'orderStatistics',
				component: () =>
					import(/* webpackChunkName: "orderdetail" */ '@/leniuview/orderCenter/buffetManagement/orderStatistics'),
				name: '订单统计',
				id: 2063000,
				meta: { title: '订单统计', roles: [2063000] }
			},
			// {
			//   path: "courierDishStatisticscommon",
			//   component: () =>
			//     import(/* webpackChunkName: "orderdetail" */ "@/leniuview/orderCenter/buffetManagement/courierDishStatisticscommon"),
			//   name: "配送明细",
			//   id: 2064000,
			//   meta: { title: "配送明细", roles: [2064000]  }
			// },
			// {
			//   path: "orderShenhe",
			//   component: () =>
			//     import(/* webpackChunkName: "orderdetail" */ "@/leniuview/orderCenter/buffetManagement/orderShenhe"),
			//   name: "退款纠错审核",
			//   id: 2065000,
			//   meta: { title: "退款纠错审核", roles: [2065000]  }
			// },
			{
				path: 'orderShenhe',
				component: () =>
					import(/* webpackChunkName: "orderShenhe" */ '@/leniuview/orderCenter/buffetManagement/refund'),
				name: '退款纠错审核',
				id: 2065000,
				redirect: 'orderShenhe/progress',
				meta: { title: '退款/纠错审核', roles: [2065000] },
				children: [
					{
						path: 'progress',
						component: () =>
							import('@/leniuview/orderCenter/buffetManagement/refund/errorCorrection'),
						name: '进行中订单',
						meta: { title: '进行中订单', roles: [2065000], noCache: true },
						hidden: true
					},
					{
						path: 'finish',
						component: () =>
							import('@/leniuview/orderCenter/buffetManagement/refund/orderShenhe'),
						name: '已完成订单',
						meta: { title: '已完成订单', roles: [2065000], noCache: true },
						hidden: true
					}
				]
			}
		]
	},
	{
		path: 'privateMangement',
		name: '包间',
		component: LayoutView,
		id: 2070000,
		meta: { title: '包间', roles: [2070000] },
		children: [
			{
				path: 'privateList',
				component: () =>
					import(/* webpackChunkName: "orderdetail" */ '@/leniuview/orderCenter/privateMangement/privateList'),
				name: '包间预定',
				id: 2071000,
				meta: { title: '包间预定', roles: [2071000] }
			}
		]
	}
	]
}

export default orderingRouter
